
// NATIVE 

// INSTALLED 
import { checkingPreload, unCheckingPreload } from '../loading';
import { setTerminalsDescansosRedux, storeTerminalDescansosRedux } from './terminalDescansosSlice';
import { createTerminalService, desactiveTerminalService,  
         getTerminalsByPaginateService, getTerminalsService, updateTerminalDetailService } from '../../services/terminals';
import { activeTerminalDescansoService, createTerminalDescansoService, desactiveTerminalDescansoService, getTerminalDescansoDetailService, getTerminalDescansosService, updateTerminalDescansosDetailService } from '../../services/terminsl.descanso.service';




// CUSTOM 




export const getTerminalDescansosStore = (): any => {

    return async( dispatch: any ) => {
       

        await dispatch( checkingPreload() );

        const result = await  getTerminalDescansosService();

       
        if ( result.ok ) {
          await dispatch( setTerminalsDescansosRedux(result.data) );
        }

        dispatch( unCheckingPreload() );

        return result;


    }

  
}




export const getTerminalsByPagination = (page:number): any => {

    return async( dispatch: any ) => {


      await dispatch( checkingPreload() );
  
       

      const result = await  getTerminalsByPaginateService(page);


      if ( result.ok ) {
          await dispatch( setTerminalsDescansosRedux(result.data) );
      }
    
      dispatch( unCheckingPreload() );
      
      return result;
        
    }

}

export const storeCreateTerminalDescansos = (terminal: any, percentage:any): any => {

    return async( dispatch: any ) => {


      const dataSave = {
         ...terminal,
         typeTerminal: terminal.typeTerminal.value

      }

      const result = await  createTerminalDescansoService(dataSave, percentage);

    
      if ( result.ok ) {
          await dispatch( setTerminalsDescansosRedux(result.data) );
      }

      
      return result;
        
    }
}



export const storeDetailTerminalDescanso = (terminalId: string): any => {
    

  return async( dispatch: any ) => { 


      await dispatch( checkingPreload() );
      

      const result = await  getTerminalDescansoDetailService(terminalId);
    

      if ( result.ok ) {
           await dispatch( storeTerminalDescansosRedux(result.data) );
      }

      dispatch( unCheckingPreload() );

      return result;

  }

    
}



export const storeEditTerminalDescansos = (terminal: any): any => {
    

  return async( dispatch: any ) => { 
      

      const dataUpdate = {
         ...terminal,
         typeTerminal: terminal.typeTerminal.value,
         terminalId: terminal.terminalId
       }


      const result = await  updateTerminalDescansosDetailService(dataUpdate);
    

      if ( result.ok ) {
        await dispatch( setTerminalsDescansosRedux(result.data) );
      }


      return result;

  }

    
}





export const storeDesactiveTerminalDescanso = (terminalId: string): any => {
    

  return async( dispatch: any ) => { 

      await dispatch( checkingPreload() );

      const result = await  desactiveTerminalDescansoService(terminalId);
      
      
      if ( result.ok ) {
          await dispatch( setTerminalsDescansosRedux(result.data) );
      }

      dispatch( unCheckingPreload() );

      return result;

  }

    
}




export const storeActiveTerminalDescanso = (terminalId: string): any => {
  

  return async( dispatch: any ) => { 

      await dispatch( checkingPreload() );

      const result = await  activeTerminalDescansoService(terminalId);


      if ( result.ok ) {
          await dispatch( setTerminalsDescansosRedux(result.data) );
      }

      dispatch( unCheckingPreload() );

      return result;

  }

    
}